export default "__VITE_ASSET__bb976428__"